import React from 'react';
import Border from '../common/border';
import ActivityTitle from '../common/ActivityTitle';
import ImageCarousel from '../common/ImageCarousel';

export interface Airport {
  name: string;
  code: string;
  city: string;
  state: string;
  country: string;
  type: 'pickup' | 'dropoff' | 'both';
  imageUrl: string[];
  _id: string;
}

interface AirportsProps {
  airports: Airport[];
}

const Airports: React.FC<AirportsProps> = ({ airports }) => {
  if (!airports || airports.length === 0) {
    return null;
  }

  return (
    <div className='mt-8'>
      <ActivityTitle title={'Pickup and Dropoff '} className='' />
      <div className='flex flex-wrap gap-5 pb-2 mt-2 w-full'>
        {airports.map((a, idx) => {
          const airportCard = (
            <div style={{ width: '135px' }}>
              <div
                style={{ width: '135px', height: '77px' }}
                className='mb-2 overflow-hidden rounded-[6px]'
              >
                <ImageCarousel
                  images={a.imageUrl || []}
                  alt={a.name}
                  className='h-full w-full'
                  imageClassName='object-cover rounded-[6px]'
                  showNavigation={true}
                  navigationId={`airport-${idx}`}
                  buttonSize='sm'
                  loop={false}
                  enableFullscreen={true}
                  fullscreenTitle={a.name}
                />
              </div>
              <h4
                className='text-[12px] font-normal text-black leading-[15px] mb-1 overflow-hidden'
                style={{
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  height: '30px', // Fixed height for exactly 2 lines (15px line-height * 2)
                  minHeight: '30px',
                }}
              >
                {a.name}
                {a.code && (
                  <span className='text-[12px] text-darkgrey ml-1'>
                    ({a.code})
                  </span>
                )}
              </h4>
              <div className='space-y-0.5'>
                {[a.city, a.state, a.country].filter(Boolean).length > 0 && (
                  <p className='text-[10px] text-darkgrey capitalize'>
                    {[a.city, a.state, a.country].filter(Boolean).join(', ')}
                  </p>
                )}
                {a.type && (
                  <div className='flex gap-1 mt-1'>
                    {a.type === 'both' ? (
                      <>
                        <span className='inline-block px-2 py-0.5 text-[9px] font-medium text-green-700 bg-green-100 rounded-md'>
                          Pickup
                        </span>
                        <span className='inline-block px-2 py-0.5 text-[9px] font-medium text-blue-700 bg-blue-100 rounded-md'>
                          Dropoff
                        </span>
                      </>
                    ) : a.type === 'pickup' ? (
                      <span className='inline-block px-2 py-0.5 text-[9px] font-medium text-green-700 bg-green-100 rounded-md'>
                        Pickup
                      </span>
                    ) : (
                      <span className='inline-block px-2 py-0.5 text-[9px] font-medium text-blue-700 bg-blue-100 rounded-md'>
                        Dropoff
                      </span>
                    )}
                  </div>
                )}
              </div>
            </div>
          );

          return (
            <div key={`${a.code}-${idx}`} className='cursor-pointer'>
              {airportCard}
            </div>
          );
        })}
      </div>
      <Border />
    </div>
  );
};

export default Airports;
